/**
 * Mock da apuração semanal do PLCom — dados extraídos do protótipo
 * "Apuração Semanal PLcom.html" (referência em
 * documentacao-metodologias/reforma-tributaria/Apuração Semanal PLcom (1).html).
 *
 * weeks: apuração das notas por data de emissão (4 semanas de setembro/2026).
 * L: lançamentos "do mês" sem data de nota, digitados nas fórmulas da planilha.
 */

export const SEMANAS_MOCK = [
  {
    vendas: 1342051.28,
    dev: 1227.76,
    icms_deb: 195833.01,
    ipi_deb: 22301.61,
    pis_deb: 18358.57,
    cof_deb: 84560.69,
    st: 9590.22,
    icms_cred: 1201.39,
    ipi_cred: 38.65,
    pis_cred: 381.49,
    cof_cred: 1757.15,
    n_saidas: 16,
    n_dev: 1,
    n_ent: 7,
    n_st: 2,
  },
  {
    vendas: 183330.6,
    dev: 54426.97,
    icms_deb: 24202.81,
    ipi_deb: 889.67,
    pis_deb: 2606.82,
    cof_deb: 12007.18,
    st: 14615.29,
    icms_cred: 2177.08,
    ipi_cred: 0.0,
    pis_cred: 862.12,
    cof_cred: 3970.99,
    n_saidas: 33,
    n_dev: 1,
    n_ent: 0,
    n_st: 17,
  },
  {
    vendas: 25968.23,
    dev: 131219.93,
    icms_deb: 2340.61,
    ipi_deb: 0.0,
    pis_deb: 389.86,
    cof_deb: 1795.7,
    st: 0.0,
    icms_cred: 7059.78,
    ipi_cred: 1315.59,
    pis_cred: 2026.92,
    cof_cred: 9336.19,
    n_saidas: 8,
    n_dev: 12,
    n_ent: 0,
    n_st: 0,
  },
  {
    vendas: 8613.22,
    dev: 0.0,
    icms_deb: 1535.76,
    ipi_deb: 0.0,
    pis_deb: 116.78,
    cof_deb: 537.89,
    st: 0.0,
    icms_cred: 0.0,
    ipi_cred: 0.0,
    pis_cred: 0.0,
    cof_cred: 0.0,
    n_saidas: 6,
    n_dev: 0,
    n_ent: 0,
    n_st: 0,
  },
];

export const LANC_MES = {
  servicos: 408958.9,
  ajuste_liquido: -19629.27,
  pis_deb_serv: 3377.95,
  cof_deb_serv: 15559.06,
  pis_deb_adj: -0.15,
  cof_deb_adj: -3.28,
  iss: 12254.07,
  pis_cred_energia: 3.16,
  cof_cred_energia: 14.53,
  pis_cred_aluguel: 825.0,
  cof_cred_aluguel: 3800.0,
  pis_cred_adj_rev: -17.81,
  cof_cred_adj_rev: -82.01,
  pis_cred_devcompra: -218.37,
  cof_cred_devcompra: -3.61,
  ipi_cred_devcompra: 16.6,
};

/** Total a recolher da planilha de teste, para a nota de conferência. */
export const PLAN_TOTAL = 388405.28;

export const TRIBUTOS = ["icms", "ipi", "pis", "cofins"];
export const TRIBUTO_NOME = {
  icms: "ICMS",
  ipi: "IPI",
  pis: "PIS",
  cofins: "COFINS",
};

/**
 * Blocos de lançamento manual da aba IMPOSTOS.
 * campos: [tributo, lado (deb|cred|none), sinal, onde cai na apuração].
 */
export const BLOCOS_MANUAIS = [
  {
    id: "saldo",
    titulo: "Saldo credor anterior",
    origem: "Planilha: Saldo credor",
    nota: "Soma ao crédito do tributo. É o saldo do mês anterior: informe uma vez, normalmente na semana 1. O saldo que uma semana deixa para a seguinte já é descontado no consolidado.",
    campos: [
      ["icms", "cred", 1, "crédito de ICMS"],
      ["pis", "cred", 1, "crédito de PIS"],
      ["cofins", "cred", 1, "crédito de COFINS"],
      ["ipi", "cred", 1, "crédito de IPI"],
    ],
  },
  {
    id: "pet",
    titulo: "Notas Petrobras",
    origem: "Planilha: Notas Petrobras",
    nota: "Soma ao crédito de PIS e COFINS.",
    campos: [
      ["pis", "cred", 1, "crédito de PIS"],
      ["cofins", "cred", 1, "crédito de COFINS"],
    ],
  },
  {
    id: "baixa",
    titulo: "Nota de baixa de estoque",
    origem: "Planilha: Nota baixa estoque NF",
    nota: "Soma ao débito do tributo.",
    campos: [
      ["icms", "deb", 1, "débito de ICMS"],
      ["pis", "deb", 1, "débito de PIS"],
      ["cofins", "deb", 1, "débito de COFINS"],
    ],
  },
  {
    id: "areia",
    titulo: "NF de areia (regime cumulativo)",
    origem: "Planilha: NF areia",
    nota: "PIS e COFINS reduzem o crédito dos dois tributos. O ICMS soma ao crédito de ICMS.",
    campos: [
      ["pis", "cred", -1, "reduz o crédito de PIS"],
      ["cofins", "cred", -1, "reduz o crédito de COFINS"],
      ["icms", "cred", 1, "crédito de ICMS"],
    ],
  },
  {
    id: "nf",
    titulo: "NF com carta de não aproveitamento de ICMS",
    origem: "Planilha: NF",
    nota: "O ICMS soma ao débito de ICMS. PIS e COFINS não entram em nenhuma fórmula da planilha e ficam só como registro.",
    campos: [
      ["pis", "none", 0, "sem efeito na planilha"],
      ["cofins", "none", 0, "sem efeito na planilha"],
      ["icms", "deb", 1, "débito de ICMS"],
    ],
  },
];

/**
 * Gera os intervalos das 4 semanas para uma competência (ISO yyyy-mm-dd do 1º dia).
 * Semana 4 vai até o último dia do mês.
 */
export function rangesSemanais(competenciaISO) {
  const [ano, mes] = competenciaISO.split("-").map(Number);
  const ultimoDia = new Date(ano, mes, 0).getDate();
  return [
    `01 a 07/${String(mes).padStart(2, "0")}`,
    `08 a 14/${String(mes).padStart(2, "0")}`,
    `15 a 21/${String(mes).padStart(2, "0")}`,
    `22 a ${ultimoDia}/${String(mes).padStart(2, "0")}`,
  ];
}
